<template>
    <div class="card-container">
        <common-top-form :model="formModel" :submitService="submitService" buttonType="warning" :show="false"
                         :submitData="submitData" @success="onSuccess">
            <select-organs v-model="formModel.tatSimpleId"></select-organs>
            <el-form-item label="路线名称" prop="shortName">
                <el-select v-model="formModel.shortName" filterable>
                    <el-option
                        v-for="item in topShortNames"
                        :key="item.id"
                        :label="item.shortName"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="预留手机号">
                <el-input type="text" maxlength="20" v-model="formModel.memPhone" placeholder="请输入预留手机号"></el-input>
            </el-form-item>
            <el-form-item label="会员名称">
                <el-input type="text" maxlength="20" v-model="formModel.memName" placeholder="请输入会员名称"></el-input>
            </el-form-item>
            <el-form-item label="订单号">
                <el-input v-model="formModel.odrNo" maxlength="50" placeholder="请输入交易订单号"></el-input>
            </el-form-item>
            <el-form-item label="交易状态">
                <el-select v-model="formModel.status">
                    <el-option
                        v-for="item in tranStatus"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="订单支付状态">
                <el-select v-model="formModel.tradeStatus">
                    <el-option
                        v-for="item in tranStatus"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="提现状态">
                <el-select v-model="formModel.settlementStatus">
                    <el-option
                        v-for="item in tranStatus"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="银行名称">
                <el-select v-model="formModel.bankName" filterable>
                    <el-option
                        v-for="item in BankNames"
                        :key="item.dictValue"
                        :label="item.remark"
                        :value="item.dictValue">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="储蓄卡号">
                <el-input v-model="formModel.cardNo" maxlength="50" placeholder="请输入储蓄卡号"></el-input>
            </el-form-item>
            <el-form-item label="交易时间">
                <el-date-picker
                    v-model="time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column prop="tatName" label="机构简称" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="chnFeeName" label="路线名称" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="orderNo" label="交易订单号" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="subMerchantName" label="用户名" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="mobile" label="预留手机号" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column prop="identity" label="身份证号" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="tradeAmount" label="交易金额" min-width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p>{{toDoubleThousands(scope.row.tradeAmount * 100 / 10000)}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="realAmt" label="实际到账" min-width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p>{{toDoubleThousands(scope.row.realAmt * 100 / 10000)}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="tradeRate" label="交易费率" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column prop="settlementFee" label="结算费率" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column prop="status" label="交易状态" min-width="130" :formatter="formatTranStatus"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="tradeStatus" label="订单支付状态" :formatter="formatTranStatus" min-width="130"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="settlementStatus" label="提现状态" :formatter="formatTranStatus" min-width="130"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="bankCardNo" label="储蓄卡号" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="openBankName" label="储蓄卡所在行" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="交易时间" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="respmsg" label="备注" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" min-width="100" v-if="hasPerm('/tranQry/getProfitDtl_q')">
                <template slot-scope="scope">
                    <el-button type="text" @click="reissueNotice(scope.row.orderNo)"
                               v-if="scope.row.tradeStatus == 1 && scope.row.settlementStatus == 2">代付
                    </el-button>
                    <p v-else>--</p>
                </template>
            </el-table-column>
        </common-table>

        <form-dialog ref="formDialog" formDialogTitle="代付" :model="dialogModel" labelWidth="180px" class="over" @success="dialogSuccess"
                     :dialogService="dialogService" :submitData="dialogData" :rules="dialogRules" @close="dialogClose">
            <el-form-item label="银行卡号" prop="bankCardNo">
                <el-input type="text" maxlength="50" v-model="dialogModel.bankCardNo" placeholder="请输入银行卡号"></el-input>
            </el-form-item>
            <el-form-item label="银行名称" prop="openBankName">
                <el-select v-model="dialogModel.openBankName" filterable>
                    <el-option
                        v-for="item in dialogBankNames"
                        :key="item.dictValue"
                        :label="item.remark"
                        :value="item.dictValue">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="银行预留手机号" prop="mobile">
                <el-input v-model="dialogModel.mobile" placeholder="请输入银行预留手机号"></el-input>
            </el-form-item>
        </form-dialog>

    </div>
</template>

<script>
    import CommonTopForm from 'components/common/CommonTopForm'
    import CommonTable from 'components/common/CommonTable'
    import SelectOrgans from 'components/business/SelectOrgans'
    import FormDialog from '../../dialog/FormDialog'

    import OrganService from 'service/OrganService'
    import StatisticsService from 'service/StatisticsService'
    import ChannelRateService from 'service/ChannelRateService'
    import TransactionService from 'service/TransactionService'
    import TimeRange from 'service/constant/TimeRange'
    import privateKey from 'service/constant/privateKey'
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapGetters} from 'vuex'

    export default {
        name: "hbcollection",
        components: {
            CommonTopForm, CommonTable, SelectOrgans, FormDialog
        },
        data() {
            return {
                formModel: {
                    shortName: '',
                    tatSimpleId: '',
                    odrNo: '',
                    memPhone: '',
                    memName: '',
                    status: '',
                    bankName: '',
                    cardNo: '',
                    tradeStatus: '',
                    settlementStatus: '',
                },
                tableData: [],
                submitService: TransactionService.HbWeizhInfo,
                all: [{
                    id: '',
                    simpleName: '全部'
                }],
                shortNames: [],
                topShortNames: [],
                allChnName: [{
                    id: '',
                    shortName: '全部'
                }],
                tranStatus: [{
                    dictKey: '',
                    dictValue: '全部'
                }, {
                    dictKey: '0',
                    dictValue: '处理中'
                }, {
                    dictKey: '1',
                    dictValue: '成功'
                }, {
                    dictKey: '2',
                    dictValue: '失败'
                }, {
                    dictKey: '3',
                    dictValue: '超时取消'
                },],
                BankNames: [],
                dialogBankNames: [],
                time: TimeRange.dayRange,
                params: {},
                page: {},
                isPage: false,
                dialogModel: {
                    bankCardNo: '',
                    openBankName: '',
                    mobile: '',
                },
                dialogRules: {
                    bankCardNo: [{
                        required: true,
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback(new Error('请输入银行卡号'));
                                return
                            }
                            if (value) {
                                this.tableData.forEach(item => {
                                    if (item.id == this.infoId && value == item.bankCardNo) {
                                        return callback(new Error('不能与原订单卡号重复'))
                                    }
                                });
                                callback();
                            }
                        }
                    }],
                    openBankName: [{
                        required: true,
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback(new Error('请输入银行名称'))
                                return
                            }
                            if (value) {
                                this.tableData.forEach(item => {
                                    if (item.id == this.infoId && value == item.openBankName) {
                                        return callback(new Error('不能与原订单银行重复'))
                                    }
                                });
                                callback();
                            }
                        }
                    }],
                    mobile: [{
                        required: true,
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback(new Error('请输入预留手机号'));
                            }
                            let reg = /^1[0-9]{10}$/;
                            if (!reg.test(value)) {
                                callback(new Error('请正确输入预留手机号'));
                            }
                            callback();
                        }
                    }],
                },
                dialogService: TransactionService.HbWeizhInfoAgain,
                infoId:null
            }
        },
        inject: ['reload'],
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        mounted() {
            this.load();
        },
        computed: {
            submitData() {
                if (this.time == null || this.time == '') {
                    this.time = [];
                }
                this.params = {
                    tatSimpleId: this.formModel.tatSimpleId,
                    shortName: this.formModel.shortName,
                    odrNo: this.formModel.odrNo.trim(),
                    memName: this.formModel.memName.trim(),
                    status: this.formModel.status,
                    bankName: this.formModel.bankName,
                    tradeStatus: this.formModel.tradeStatus,
                    settlementStatus: this.formModel.settlementStatus,
                    cardNo: this.formModel.cardNo.trim(),
                    memPhone: this.formModel.memPhone.trim(),
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };
                if (this.time.length) {
                    this.params.startDate = this.time[0];
                    this.params.endDate = this.time[1];
                }

                return this.params;
            },
            dialogData() {
                return {
                    bankCardNo: this.dialogModel.bankCardNo,
                    openBankName: this.dialogModel.openBankName,
                    mobile: this.dialogModel.mobile,
                    orgTradeNo: this.infoId
                }
            },
            ...mapGetters(['serverType', 'tatId', 'userId'])
        },
        methods: {
            formatTranStatus(row, column, cellValue) {
                let value = '';
                this.tranStatus.forEach(item => {
                    if (item.dictKey == cellValue) {
                        value = item.dictValue;
                    }
                });
                return value ? value : '--';
            },
            load() {
                this.formModel = {
                    shortName: '',
                    tatSimpleId: '',
                    odrNo: '',
                    memPhone: '',
                    memName: '',
                    status: '',
                    bankName: '',
                    cardNo: '',
                    tradeStatus: '',
                    settlementStatus: '',
                };

                this.page = this.$refs.commonTable.page;

                this.getShortNames('hb', (res) => {
                    this.topShortNames = [...this.allChnName, ...res];
                });
                this.getTypeNames('bankAbbreviation', (res) => {
                    this.dialogBankNames = res;
                    this.BankNames = [{
                        remark: '全部',
                        dictValue: ''
                    }, ...res]
                });
                this.getList();
            },
            reissueNotice(id) {
                this.infoId = id;
                this.$refs.formDialog.open();
            },
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(this.submitService, this.submitData, res => {
                    this.doCheck(res, res => {
                        this.onSuccess(res);
                        this.isPage = false;
                    });
                }, '信息获取失败')
            },
            onSuccess(res) {
                this.doCheck(res, res => {
                    const result = res.contents;
                    this.tableData = result.rows;

                    this.page.currentPage = result.current;
                    this.page.total = result.total;
                    this.page.pageSize = result.size;
                });
            },
            dialogSuccess(res) {
                this.doCheck(res, res => {
                    this.showSuccess(res.respMsg);
                    this.$refs.formDialog.closeDialog();
                    this.isPage = true;
                    this.getList();
                });
            },
            dialogClose() {
                this.dialogModel = {
                    bankCardNo: '',
                    openBankName: '',
                    mobile: '',
                }
            }
        }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/page/TransactionManage/HBCollection.vue